import React from 'react'

import UsersList from './UsersList'
import UsersLoader from '../_load/UsersLoader'

const PageContent = () => {
  return (
    <UsersLoader>
      <UsersList />
    </UsersLoader>
  )
}

export default PageContent
